import React, { useState } from 'react'
import { Button, Form, Modal } from 'react-bootstrap'
import axios from '../../../adapters/API/axios';
import Swal from 'sweetalert2';

function ModalLupaPassword ( {
    showLupaPassword,
    setShowLupaPassword
} )
{

    const [ email, setEmail ] = useState( "" );

    const handleCloseLupaPassword = () =>
    {
        setShowLupaPassword( false );
        setEmail( '' );
    };


    const handleSubmitEmail = async ( event ) =>
    {
        event.preventDefault()
        const data = {
            email: email,
        }
        try {
            const response = await axios.post( `/api/request-reset-password/`, data,
                {
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json',
                        withCredentials: true,
                    },
                    // httpsAgent: {
                    //     rejectUnauthorized: false,
                    // }
                }

            );
            handleCloseLupaPassword();
            Swal.fire( {
                icon: 'success',
                title: 'Email reset password diterima!',
                text: `${response.data.message}`,
            } )
        } catch ( err ) {
            console.log( err )
            if ( err?.response.status === 500 ) {
                Swal.fire( {
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Terjadi kesalahan pada server',
                } )
            } else if ( err?.response.status === 400 ) {
                Swal.fire( {
                    icon: 'error',
                    title: 'Oops...',
                    text: `${err.response?.data.email[ 0 ]}`,
                } )
            }


        }
    };


    return (
        <Modal
            show={ showLupaPassword }
            onHide={ handleCloseLupaPassword }
            backdrop="static"
            keyboard={ false }
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title style={ { fontFamily: 'Poppins-Medium' } }>
                    Lupa Password
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={ handleSubmitEmail }>
                    <Form.Group className="mb-3">
                        <Form.Label style={ formStyles.label } htmlFor='emailRecovery'>Email*</Form.Label>
                        <Form.Control
                            id='email'
                            type="text"
                            // disabled={ disabled }
                            onChange={ ( e ) => setEmail( e.target.value ) }
                            value={ email }
                            required
                            placeholder="Masukkan email anda"
                            style={ formStyles.input }
                        />
                    </Form.Group>
                    <div className="d-grid gap-2 my-4">
                        <Button
                            type="submit"
                            id='actionButton'
                            variant='btn'
                            disabled={ !email }
                        // disabled={ disabled }
                        >
                            Submit
                        </Button>
                    </div>
                </Form>
            </Modal.Body>

        </Modal>
    )
}

export default ModalLupaPassword


const formStyles = {
    label: {
        fontFamily: 'Poppins-Medium',
        color: '#222',
    },
    input: {
        color: '#222',
        fontFamily: 'Poppins-Regular',
        minHeight: '50px',
        borderColor: '#ced4da', // Initial border color
    },
};